export default {
    setCurrentSite(state,payload) {
        state.currentSite = payload;
        localStorage.setItem('currentSite', payload.id)
    },
    setSites(state,payload) {
        state.sites = payload;
    }
}